// extracted by mini-css-extract-plugin
export var select = "_pc-0";